<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>       

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage['SMB']['PPS']}}</h2>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["AGT"]}} <span class="required" />:</span>
                                <customtreeselect :multiple="false"
                                                  :options="dd_agentgroup"
                                                  :clearable="false"
                                                  :flat="true"
                                                  :defaultExpandLevel="Infinity"
                                                  @input="selectAgentOptions"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  v-model="searchAgent"
                                                  ref="AGI" />
                                <span class="ErrMsg">{{ ValidationErrMsg('searchAgent','GL','AGT') }}</span>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["CI"]}} <span class="required" />:</span>
                                <treeselect :multiple="false"
                                            :load-options="loadCurrencyOptions"
                                            :options="ddCurrencyList"
                                            :auto-load-root-options="convertToBool(searchCurrency)"
                                            :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                            @input="CurrencyChange"
                                            v-model="searchCurrency"
                                            ref="CI" />
                                <span class="ErrMsg">{{ ValidationErrMsg('searchCurrency','MEM','CI') }}</span>
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton class='searchBtn' size="sm" ref="search" block color="success" @click="getPrizeList()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>
        </div>
        <div class="container-fluid">
            <div class='table-wrapper'>
                <div>
                    <CRow>
                        <CCol col="12">
                            <h6 class="card-title section-title2"><span>1</span>{{this.getLanguage["PPS"]["PS"]}}</h6>
                        </CCol>
                    </CRow>
                    <div class="paddingdls" v-if="!rendering">{{this.getLanguage['DLSS']['CBAC']}}</div>
                    <div v-else style="margin-left: 30px">
                        <CRow>
                            <CCol col="3">
                                <label class="col-form-label-sm">{{this.getLanguage["PPS"]["PN"]}}<span class="required" /> :</label>
                                <CInput :placeholder="getLanguage['PPS']['PN']" size="sm" :value="obj_Prize.PN" @change="v => obj_Prize.PN = v" :disabled="obj_Prize.I > 0" ref="PN"></CInput>
                                <span class="ErrMsg">{{ ValidationPrizeErrMsg('PN','PPS','PN') }}</span>
                            </CCol>
                            <CCol col="2">
                                <label class="col-form-label-sm">{{this.getLanguage["PPS"]["PG"]}}<span class="required" /> :</label>
                                <treeselect :multiple="false"
                                            :options="dd_DLSPromoGroup"
                                            :clearable="false"
                                            :placeholder="getLanguage['PPS']['PG']"
                                            v-model="obj_Prize.PG"
                                            ref="PG" />
                                <span class="ErrMsg">{{ ValidationPrizeErrMsg('PG','PPS','PG') }}</span>
                            </CCol>
                            <CCol col="2">
                                <div v-if="obj_Prize.PG==1">
                                    <label class="col-form-label-sm">{{ this.getLanguage['DLSP']['CA'] }}<span class="required" /> : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                                    <CInput :prepend="str_preText"
                                            :placeholder="getLanguage['DLSP']['CA']"
                                            size="sm" :value="ThousandSeparator(obj_Prize.CA, getThousandCurrency ? 3 : 2)"
                                            @change="v => obj_Prize.CA = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)">
                                    </CInput>
                                    <span class="ErrMsg">{{ ValidationPrizeErrMsg('CA', 'DLSP', 'CA') }}</span>
                                </div>
                                <div v-else>
                                    <label class="col-form-label-sm">{{ this.getLanguage['DLSP']['NOS'] }}<span class="required" /> :</label>
                                    <CInput :placeholder="getLanguage['DLSP']['NOS']" size="sm" v-model="obj_Prize.NOS" v-if="obj_Prize.PG==2"></CInput>
                                    <span class="ErrMsg">{{ ValidationPrizeErrMsg('NOS', 'DLSP', 'NOS') }}</span>
                                </div>
                            </CCol>
                            <CCol col="3">
                                <div v-if="obj_Prize.PG==2">
                                    <label class="col-form-label-sm">{{this.getLanguage["AG"]["GP"]}} <span class="required" />:</label>
                                    <treeselect :multiple="false"
                                                :disabled="obj_Prize.NOS <= 0"
                                                :options="ddProviderList"
                                                :placeholder="this.utilGetDDLanguage('AG.GP')"
                                                v-model="obj_Prize.GPI"
                                                ref="GPI" />
                                    <span class="ErrMsg">{{ ValidationPrizeErrMsg('GPI','AG','GP') }}</span>
                                </div>
                            </CCol>

                            <CCol col="2" class="mt-4 pt-1">
                                <CButton size="sm" color="outline-info" v-if="checkModuleAccess2(constAccessType.add)" @click="savePrize()"><span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AN"]}}</CButton>
                            </CCol>
                        </CRow>
                        <CRow>
                            <div class="col pageBtn justify-content-end">
                                <button @click="ctrPage(+int_Page - 1)">
                                    <span class="arrowLeft"></span>
                                </button>
                                <input class="page-control"
                                       v-model="int_Page"
                                       type="number"
                                       v-shortkey.avoid
                                       @keyup="ctrPage(+int_Page,0)" />
                                <span class="tableItemCount">/ {{int_TP}}</span>
                                <button @click="ctrPage(+int_Page + 1)">
                                    <span class="arrowRight"></span>
                                </button>
                            </div>
                        </CRow>
                        <div class="custom-table-wrapper mt-2 mb-4">
                            <table class='custom-table afb-blue'>
                                <thead>
                                    <tr>
                                        <th>{{ this.getLanguage["GL"]["NO"] }}</th>
                                        <th v-if=" checkModuleAccess2(constAccessType.delete)">{{getLanguage["GL"]["ACT"]}}</th>
                                        <!--<th v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.add)">{{getLanguage["PM"]["RS"]}}</th>-->


                                        <th>{{ this.getLanguage["PM"]["AGI"] }}<i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i></th>
                                        <th>
                                            {{ this.getLanguage["MEM"]["CI"] }}
                                            <i @click="setSortTable('CI')" :class="setSortLogo('CI')" class="sortlogo"></i>
                                        </th>
                                        <th>
                                            {{ this.getLanguage["PPS"]["PN"] }}
                                            <i @click="setSortTable('PN')" :class="setSortLogo('PN')" class="sortlogo"></i>
                                        </th>
                                        <th>
                                            {{ this.getLanguage["PPS"]["PG"] }}
                                            <i @click="setSortTable('PG')" :class="setSortLogo('PG')" class="sortlogo"></i>
                                        </th>
                                        <th class="tableCtnRight">
                                            {{ this.getLanguage["AG"]["QUANT"] }}
                                            <i @click="setSortTable('CA')" :class="setSortLogo('CA')" class="sortlogo"></i>
                                        </th>
                                        <th>
                                            {{ this.getLanguage["AG"]["GP"] }}
                                            <i @click="setSortTable('GPN')" :class="setSortLogo('GPN')" class="sortlogo"></i>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="arr_PrizeSetting && arr_PrizeSetting.length == 0">
                                        <td colspan="100%">{{this.getLanguage['GL']['NR']}}</td>
                                    </tr>
                                    <tr v-else v-for="(data,index) in arr_PrizeSetting">
                                        <td>{{ CountItem(index+1) }}</td>
                                        <td v-if=" checkModuleAccess2(constAccessType.delete)">
                                            <span id="actionBtnCol">
                                                <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.delete) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" style="display: block;">
                                                    <i class="cil-trash" @click='removePrize(data)'></i>
                                                    <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                                </div>
                                                <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.delete) && (isSENS == 1 && data.AGI != curAGI)" style="display: block;">
                                                    <i class="cil-trash"></i>
                                                    <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                                </div>

                                            </span>
                                        </td>
                                        <td>{{ data.GN }} ({{ data.GPC }})</td>
                                        <td>
                                            <span class="grid-line">{{ renderCurrency(data.ISOC) }}</span>
                                        </td>
                                        <td>
                                            <span class="grid-line bold">{{ data.PN }}</span>
                                        </td>
                                        <td>
                                            <span class="grid-line">{{ renderDLSPromoGroup(data.PG) }}</span>
                                        </td>
                                        <!-- Quantity -->
                                        <td class="tableCtnRight">
                                            <span v-if="data.PG == 1" class="grid-line">{{getLanguage["DLSP"]["CA"]}} = {{ formatNumber(data.CA, 2, data.CS) }}</span>
                                            <span v-if="data.PG == 2" class="grid-line">{{renderDLSPromoGroup(2)}} =  {{ data.NOS }}</span>
                                        </td>
                                        <!-- Quantity End  -->
                                        <!-- Gameprovider  -->
                                        <td>
                                            <span v-if="data.PG == 2" class="grid-line">{{ renderProviderName(data.GPN) }}</span>
                                        </td>
                                        <!-- Gameprovider end  -->
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <CRow>
                        <CCol col="12">
                            <h6 class="card-title section-title2"><span>2</span>{{this.getLanguage["PPS"]["PPS"]}}</h6>
                        </CCol>
                    </CRow>
                    <div class="paddingdls" v-if="!rendering">{{this.getLanguage['DLSS']['CBAC']}}</div>
                    <div v-else style="margin-left: 30px">
                        <CRow>
                            <CCol col="3" class="pr-0">
                                <label class="col-form-label-sm">{{this.getLanguage["PPS"]["PPN"]}}<span class="required" /> :</label>
                                <CInput :placeholder="getLanguage['PPS']['PPN']" size="sm" v-model="obj_PrizePool.APPN" ref="APPN"></CInput>
                                <span class="ErrMsg">{{ ValidationPrizePoolErrMsg('APPN','PPS','PPN') }}</span>
                            </CCol>
                            <CCol col="2" class="mt-4 pt-1">
                                <CButton size="sm" color="outline-info" v-if="checkModuleAccess2(constAccessType.add)" @click="addPrizePool()"><span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AN"]}}</CButton>
                            </CCol>
                        </CRow>
                        <div v-if="!obj_PrizePoolMain || !obj_PrizePoolMain.PrizePoolMainList || obj_PrizePoolMain.PrizePoolMainList.length == 0 || !selectedPrizePool">
                            {{this.getLanguage['GL']['NR']}}
                        </div>
                        <CRow v-else id="webTempSetting" class="my-2">
                            <CCol md="3" class="pr-0">
                                <div aria-orientation="vertical" class="nav flex-column nav-pills h-100" style="cursor: auto">
                                    <div v-for="(data,index) in obj_PrizePoolMain.PrizePoolMainList" v-if="data.RS > 0">
                                        <a style="cursor: default;" :class="['d-flex nav-link',{'active': data.I == selectedPrizePool.I}]" @click="selectedPrizePool.I != data.I && selectPrizePool(data)">
                                            <input type="checkbox" @click.stop="event => updatePrizePoolStatus(event, data)" :checked="data.RS==2" />
                                            <div class="ml-3 w-100" :style="{cursor: selectedPrizePool.I == data.I ? 'default': 'pointer'}">
                                                <span>{{data.PPN}}</span>
                                                <div class="custom_tooltip float-right" v-if="checkModuleAccess2(constAccessType.delete) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                                    <i class="cil-trash" @click.stop="removePrizePool(data)"></i>
                                                    <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                                </div>
                                                <div class="custom_tooltip float-right" v-if="checkModuleAccess2(constAccessType.delete) && (isSENS == 1 && data.AGI != curAGI)">
                                                    <i class="cil-trash"></i>
                                                    <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </CCol>
                            <CCol md="9">
                                <div class="sectionBg px-4">
                                    <CCol col="3" class="px-0">
                                        <label class="col-form-label-sm">{{this.getLanguage["PPS"]["PPN"]}}<span class="required" /> :</label>
                                        <CInput :placeholder="getLanguage['PPS']['PPN']" size="sm" v-model="selectedPrizePool.PPN" @change="selectedPrizePool.IsEdit = true" ref="PPN" />
                                        <span class="ErrMsg">{{ ValidationPrizePoolSettingErrMsg('PPN','PPS','PPN') }}</span>
                                    </CCol>
                                    <div class="mt-2">
                                        <div id="nav-tab" role="tablist" class="nav nav-tabs">
                                            <button :class="['py-0 nav-link',{'active':selectedLang.id == data.id}]" v-for="(data, index) in dd_language" @click="selectedLang = data">
                                                <div class="d-flex align-items-center">
                                                    <span class="flagClass mr-2" :class="mapLanguageFlag(data.id)"></span>
                                                    <span>{{data.label}}</span>
                                                </div>
                                            </button>
                                        </div>
                                        <div class="card tab-content p-2">
                                            <CCol col="4">
                                                <label class="col-form-label-sm">{{this.getLanguage["PPS"]["TIMS"]}}<span class="required" /> :</label>
                                                <CInput :placeholder="getLanguage['PPS']['TIMS']" size="sm" v-model="selectedPrizePool.TPPNL[data.id]" v-for="(data, index) in dd_language" :key="index" v-if="selectedLang.id == data.id" @change="updateTranslation" />
                                            </CCol>
                                        </div>
                                    </div>
                                    <div class="custom-table-wrapper my-4">
                                        <table class='custom-table afb-blue'>
                                            <thead>
                                                <tr>
                                                    <th style="width:80px">
                                                        {{this.getLanguage['PPS']['PNO']}}
                                                    </th>
                                                    <th style="width:250px">
                                                        {{this.getLanguage['PPS']['PN']}}
                                                    </th>
                                                    <th style="width:150px">
                                                        {{this.getLanguage['DLSS']['P']}}
                                                    </th>
                                                    <th style="width:150px">
                                                        {{this.getLanguage['DLSS']['SL']}}
                                                    </th>
                                                    <th>
                                                        {{this.getLanguage['DLSS']['SA']}}
                                                    </th>
                                                    <!--<th style="width:150px">
                                                        {{this.getLanguage['DLSS']['UPL']}}
                                                        <div class="custom_tooltip">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2" style="left: -250px; bottom: -25px; width: 320px ">{{getLanguage["HELP"]["DLSIMG"]}}</span>
                                                        </div>
                                                    </th>-->
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-for="(data,index) in selectedPrizePool.PrizePoolSetting">
                                                    <tr>
                                                        <td>{{getLanguage['PPS']['PRIZE']}} {{data.POS}}</td>
                                                        <td>
                                                            <treeselect style="width:250px"
                                                                        :multiple="false"
                                                                        :options="dd_PrizeList"
                                                                        :clearable="false"
                                                                        v-model="data.PI"
                                                                        :max-height="200"
                                                                        @input="()=>{data.IsEdit = true; selectedPrizePool.IsEdit = true;}"
                                                                        :openDirection=" index >=6 ?'above' : 'below'"
                                                                        :key="selectedPrizePool.I + '_' + data.I" />
                                                        </td>
                                                        <td>
                                                            <treeselect style="width:150px"
                                                                        :multiple="false"
                                                                        :options="dd_DLSProbability"
                                                                        :clearable="false"
                                                                        v-model="data.P"
                                                                        :max-height="200"
                                                                        @input="()=>{data.IsEdit = true; selectedPrizePool.IsEdit = true;}"
                                                                        :openDirection=" index >=6 ?'above' : 'below'"
                                                                        :key="selectedPrizePool.I + '_' + data.I" />
                                                        </td>
                                                        <td v-if="data.Edit == 1 && data.PI !=0 && data.P != 0">
                                                            <CInput :placeholder="getLanguage['DLSS']['SL']" size="sm" class="inline inline40" v-model="data.SL" @change="()=>{data.IsEdit = true; selectedPrizePool.IsEdit = true;}" :key="selectedPrizePool.I + '_' + data.I" />
                                                            <div class="custom_tooltip">
                                                                <i class="cil-x sortlogo" @click='data.Edit = 0'></i>
                                                                <span class="tooltiptext">{{getLanguage['BTN']['CLO']}}</span>
                                                            </div>
                                                        </td>
                                                        <td v-if="data.Edit == 0 && data.PI !=0 && data.P != 0">
                                                            {{data.SL}}
                                                            <div class="custom_tooltip">
                                                                <i class="cil-color-border" @click='data.Edit = 1'></i>
                                                                <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                                            </div>
                                                        </td>
                                                        <td v-if="data.PI == 0 && data.P != 0">
                                                            {{getLanguage["DLSS"]["U"]}}
                                                        </td>
                                                        <td v-if="data.P == 0">
                                                            {{getLanguage["DLSS"]["NA"]}}
                                                        </td>
                                                        <td v-if="data.P == 0 || data.PI == 0">
                                                            {{getLanguage["BTN"]["U"]}}
                                                        </td>
                                                        <td v-else>
                                                            {{data.SA}}
                                                        </td>
                                                        <!--<td>
                                                            <img :src="data.IURL?data.IURL:data.DefaultImage" width="50px" height="50px" :id="'img_' + selectedPrizePool.I + '_' + data.I"/>
                                                            <div class="custom-file" style="float: right;">
                                                                <input type="file" class="custom-file-input" name="pic" accept="image/*" @change="onFileSelected(data,$event)" required :key="selectedPrizePool.I + '_' + data.I" />
                                                                <label class="custom-file-label" v-if="data.UploadImage === null">{{ getLanguage['CTAB']['CAI'] }}</label>
                                                                <label class="custom-file-label" v-else>{{data.UploadImage.name}}</label>
                                                                <div class="invalid-feedback">{{ getLanguage['ERR']['8007'] }}</div>
                                                            </div>
                                                        </td>-->
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </CCol>
                        </CRow>
                        <header class="table-header" style="margin-left: 30px">
                            <strong></strong>
                            <div>
                                <CButton v-if="checkModuleAccess2(constAccessType.edit)" class='searchBtn' size="sm" block color="success" @click="SavePrizePoolSetting()"><span>{{this.getLanguage["BTN"]["SV"]}}</span></CButton>
                            </div>
                        </header>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { constDLSProbability, loadingFullScreen,constAccessType } from '@/modules/Constant.js'
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import genericHelper from "@/modules/GenericHelper.js";
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { mapGetters, mapActions } from 'vuex';
    import { required, numeric, requiredIf, alphaNum, decimal, minValue } from 'vuelidate/lib/validators'
    import Vue from 'vue'
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))
    Vue.use(require('vue-moment'));
    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading
        },
        data() {
            return {
                rendering: false,
                bool_showDetails: false,
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                bool_PrizeListCV: false,
                bool_PrizePoolCV: false,
                bool_PrizePoolSettingCV: false,
                // dropdown value
                ddAgentList: null,
                ddCurrencyList: null,
                // search fields
                searchAgi: null,
                searchAgent: null,
                searchCurrency: null,
                dd_DLSProbability: [],
                dd_PrizeList: [],
                bool_OnOff: false,
                bool_DROOOnOff: false,
                bool_TROOOnOff: false,
                bool_LROOOnOff: false,

                newImg: false,
                defaultImage: [],

                //  dls promo   dls promo   dls promo   dls promo   dls promo   dls promo   
                isSubAgent: false,
                int_RC: 10, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true, // Table Ascending Descending
                bool_isAMV: false, // Add Modal Visible
                bool_currencyloaded: false,
                bool_providerloaded: false,
                arr_FV: {
                    "PN": "",
                    "PG": null,
                    "AGI": null,
                    "ST": 2,
                    "CI": null,
                    "CTS": {
                        startDate: "",
                        endDate: ""
                    },
                },
                arr_PrizeSetting: [],
                obj_PrizePoolMain: null,
                obj_Prize: {
                    "I": 0,
                    "RS": 2,
                    "AGI": "",
                    "AGIT": null,
                    "PN": "",
                    "PG": 1,
                    "GPI": null,
                    "CA": 0.00,
                    "NOS": 0,
                    "CI": 0,
                },
                obj_PrizePool: {
                    "I": 0,
                    "RS": 2,
                    "AGI": "",
                    "CI": 0,
                    "APPN": null
                },
                dd_agentgroup: [],
                dd_DLSPromoGroup: [],
                dd_DLSPromoStatus: [],
                ddProviderList: [],
                bool_gameloaded: false,
                bool_PrizeCV: false,
                agentGroupId: 0,
                //dd_currency: [],
                //dd_currency2: [],
                str_preText:"",
                constAccessType: constAccessType,
                selectedPrizePool: {},
                dd_language: [],
                selectedLang: null,
            }
        },
        validations: {
            searchAgi: { required },
            searchCurrency: { required },

            obj_Prize: {
                "PN": { required },
                "PG": { required },
                "CA": {
                    required: requiredIf(function (vm) {
                        return vm.PG == 1;
                    }), decimal, minValueValue: minValue(0)
                },
                "NOS": {
                    required: requiredIf(function (vm) {
                        return vm.PG == 2;
                    }), numeric, minValueValue: minValue(0)
                },
                "GPI": {
                    required: requiredIf(function (vm) {
                        return vm.PG == 2;
                    }), numeric
                }                
            },
            obj_PrizePool: {
                "APPN": { required }
            },
            selectedPrizePool: {
                "PPN": { required }
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserMemberSC', 'getUserInfo','checkModuleAccess']),

            ...mapGetters('CurrencyInfo', ['getThousandCurrency']),
        },
        methods: {
            ...mapActions('UserInfo', ['setSearchCriteriaAGI']),
            ...mapActions('CurrencyInfo', ['setThousandCurrency']),
            getDropdownList() {
                var that = this;

                this.dd_DLSProbability = [{
                    id: 1,
                    label: this.getLanguage['DLSS']['E']
                }, {
                    id: 2,
                    label: this.getLanguage['DLSS']['M']
                }, {
                    id: 3,
                    label: this.getLanguage['DLSS']['H']
                }, {
                    id: 4,
                    label: this.getLanguage['DLSS']['VH']
                }, {
                    id: 0,
                    label: this.getLanguage['DLSS']['IPSB']
                }];

                this.dd_DLSPromoGroup = [{
                    id: 1,
                    label: this.getLanguage["MEM"]["FC"]
                }, {
                    id: 2,
                    label: this.getLanguage["MEM"]["FS"]
                    }];

                this.dd_DLSPromoStatus = [{
                    id: "2",
                    label: this.getLanguage["GL"]["AC"]
                }, {
                    id: "1",
                    label: this.getLanguage["GL"]["IAC"] + " / " + this.getLanguage["PM"]["PAST"]
                }];

                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddAgentList = d.dropdownlist;
                        }
                        else {
                            that.ddAgentList = null;
                        }

                        if (that.searchAgi != null && that.searchAgi > 0 && that.getUserInfo.AT == 3 && that.ddAgentList.length == 1) {
                            that.searchAgent = '3-' + that.searchAgi;

                            that.getDataApi(`/api/dd/cur/${that.searchAgi}`,
                                function (d2, s2) {
                                    if (s2 && d2 && d2.dropdownlist) {
                                        that.ddCurrencyList = d2.dropdownlist;
                                        if (d2.dropdownlist.length == 1) {
                                            that.searchCurrency = d2.dropdownlist[0].id;
                                        }
                                    }
                                });
                        }
                        // dls promo
                        //that.dd_agentgroupfs = that.deepClone(d.dropdownlist);

                        that.dd_agentgroup = that.deepClone(d.dropdownlist);
                        // If UserInfo is sensitive(*****)
                        if (that.getUserInfo.ISENS == 1) {
                            //Filter the list and only keep Agent (agi: 3-X)
                            // SuperAdmin(0-X), SeniorMaster(1-X), MasterAgent(2-X) will be filtered out.
                            that.dd_agentgroup = that.dd_agentgroup.filter(f => f.id == "3-" + that.getUserInfo.AGI);
                        }
                        // Disable SuperAdmin, SeniorMaster, MasterAgent in Dropdownlist.
                        if (that.dd_agentgroup.length > 0) {
                            that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                        }
                    });

                    var that = this;
            },
            renderTemplateName(TemplateName) {
                if (TemplateName && TemplateName in this.getLanguage['DLSTMP'])
                    return this.getLanguage['DLSTMP'][TemplateName];
                else
                    return TemplateName;
            },

            onFileSelected(data,event) {
                var image = this.validateFile(event);
                if (image) {                    
                    document.getElementById('img_' + this.selectedPrizePool.I + '_' + data.I).src = URL.createObjectURL(image);
                    data.UploadImage = image;
                    data.IsEdit = true;
                    this.selectedPrizePool.IsEdit = true;
                }
            },
            validateFile(event, maxFileSize = 1, validFileExtension = [".jpg", ".jpeg", ".bmp", ".gif", ".png", ".webp"]) {
                var file = null;
                this.newImg = true;
                var files = event.target.files;
                if (files && files.length > 0) {
                    var filesize = ((files[0].size / 1024) / 1024).toFixed(4); // MB

                    if (filesize <= maxFileSize) {
                        var validDimension = true;
                        var _URL = window.URL || window.webkitURL;
                        var img = new Image();
                        var that = this;
                        img.src = _URL.createObjectURL(files[0]);
                        img.onload = function () {
                            if (this.width > 100 || this.height > 100) {
                                that.showErrorMessage(that.utilGetErrorLanguage("ERR.TI"), that.utilGetErrorLanguage("ERR.UFD"));
                                event.target.value = '';
                                that.newImg = false;
                                validDimension = false;
                            } 
                        };
                        if (validDimension) {
                            var blnValid = false;
                            for (var j = 0; j < validFileExtension.length; j++) {
                                var sCurExtension = validFileExtension[j];
                                if (files[0].name.substr(files[0].name.length - sCurExtension.length, sCurExtension.length).toLowerCase() == sCurExtension.toLowerCase()) {
                                    blnValid = true;
                                    break;
                                }
                            }

                            files[0].name.substr(files[0].name.length - sCurExtension.length, sCurExtension.length)
                            var fileName = files[0].name.substr(0, files[0].name.length - sCurExtension.length).trim();
                            fileName = fileName.replace(/[^a-zA-Z0-9-_\s]/g, '');
                            if (fileName != files[0].name.substr(0, files[0].name.length - sCurExtension.length)) {
                                this.showErrorMessage(this.utilGetErrorLanguage("ERR.TI"), String.format(this.utilGetErrorLanguage("ERR.4030")));
                                event.target.value = '';
                                this.newImg = false;
                            } else if (blnValid) {
                                file = files[0];
                            } else {
                                this.showErrorMessage(this.utilGetErrorLanguage("ERR.TI"), String.format(this.utilGetErrorLanguage("ERR.4020"), files[0].name) + validFileExtension.join(", "));
                                event.target.value = '';
                                this.newImg = false;
                            }
                        }
                    } else {
                        // Outlet deposit in module 3.1, upload receipt limited size 200KB
                        if (maxFileSize == 0.2) {
                            this.showErrorMessage(this.utilGetErrorLanguage("ERR.TI"), this.utilGetErrorLanguage("ERR.4040"));
                            event.target.value = '';
                            this.newImg = false;
                        } else {
                            this.showErrorMessage(this.utilGetErrorLanguage("ERR.TI"), this.utilGetErrorLanguage("ERR.4010"));
                            event.target.value = '';
                            this.newImg = false;
                        }

                    }
                }

                return file;
            },
            loadAgentOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddAgentList = d.dropdownlist;
                        }
                        else {
                            that.ddAgentList = null;
                        }

                        callback();
                    });
            },
            selectAgentOptions(value, instanceId) {
                if (value) {
                    this.setSearchCriteriaAGI(value);
                }
                else {
                    this.setSearchCriteriaAGI(null);
                }

                this.ddCurrencyList = null;
                this.searchCurrency = null;
                this.searchAgi = 0;
                if (value) {
                    var agentList = value.split("-");
                    this.searchAgi = agentList[agentList.length - 1];
                }
            },
            loadCurrencyOptions({ action, callback, instanceId }) {
                var that = this;
                if (!this.searchAgi) {
                    callback(this.getLanguage['GL']['PSAA']);
                }
                else {
                    this.getDataApi(`/api/dd/cur/${this.searchAgi}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddCurrencyList = d.dropdownlist;
                            }
                            else {
                                that.ddCurrencyList = null;
                            }

                            callback();
                        });
                }
            },
  
            getCurrencySymbol() {
                var result = false;
                try {
                    result = this.ddCurrencyList.filter(obj => { return obj.id === this.searchCurrency })[0].label
                }
                catch (ex) {
                    result = false;
                }
                return result;
            },
            getPrizeList() {
                this.bool_PrizeListCV = true;
                this.$v.searchAgi.$touch();
                this.$v.searchCurrency.$touch();
                if (!this.$v.searchAgi.$error && !this.$v.searchCurrency.$error) {
                    this.selectedPrizePool = null;
                    var that = this;
                    this.getPrizeSetting();
                    // get free spin game provider
                    this.getDataApi(`/api/dd/game/frbprovbycategory/` + this.searchAgi + `/` + this.searchCurrency,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.bool_providerloaded = true;
                                for (var i = 0; i < d.dropdownlist.length; i++) {
                                    d.dropdownlist[i].label = that.renderProviderName(d.dropdownlist[i].label);
                                }
                                that.ddProviderList = d.dropdownlist;
                            }
                        });
                    // get language base on brand
                    this.getDataApi('/api/dd/lang/' + this.searchAgi,
                        function (d, s) {
                            if (s) {
                                that.dd_language = d.dropdownlist;
                                that.getPrizePoolSetting();
                            }
                        });
                    
                    this.obj_Prize = {
                        "I": 0,
                        "RS": 2,
                        "AGI": null,
                        "PN": "",
                        "PG": 1,
                        "CA": 0,
                        "NOS": 0,
                        "GPI": null,
                        "CI": null
                    };

                    this.obj_PrizePool = {
                        "I": 0,
                        "RS": 2,
                        "AGI": null,
                        "CI": null,
                        "APPN": null
                    };
                    this.rendering = true;
                }                
            },

            genaretePrizeDropDown(){
                let that = this;
                that.getDataApi(`/api/dd/prizelist/` + that.searchAgi + '/' + that.searchCurrency,
                    function (d, s) {
                        if (s) {
                            that.dd_PrizeList = d.dropdownlist;
                            that.dd_PrizeList[0].label = that.getLanguage["DLSS"]["TATY"];
                        }
                    });
            },
            ValidationErrMsg(value, langKey1 = "", langKey2 = "") {
                if (this.bool_PrizeListCV) {
                    if (value == 'searchAgent') {
                        var validateObj = this.$v.searchAgi
                        if (validateObj.required != undefined && !validateObj.required) {
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[langKey1][langKey2]);
                        }

                        if (this.searchAgi == 0) {
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[langKey1][langKey2]);
                        }

                    }

                    if (value == 'searchCurrency') {
                        var validateObj = this.$v.searchCurrency
                        if (validateObj.required != undefined && !validateObj.required) {
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[langKey1][langKey2]);
                        }

                        if (this.searchCurrency == 0) {
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[langKey1][langKey2]);
                        }
                    }
                }
            },
            ValidationPrizePoolErrMsg(value, langKey1 = "", langKey2 = "") {                
                if (this.bool_PrizePoolCV) {
                    var validateObj = this.$v.obj_PrizePool[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[langKey1][langKey2]);
                    }
                }
            },
            ValidationPrizePoolSettingErrMsg(value, langKey1 = "", langKey2 = "") {
                if (this.bool_PrizePoolSettingCV) {
                    var validateObj = this.$v.selectedPrizePool[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[langKey1][langKey2]);
                    }
                }
            },
            clearUploadImage() {
                const imgElements = document.querySelectorAll('.setting_img');
                imgElements.forEach(img => {
                    img.src = '';
                });
            },
            SavePrizePoolSetting() {
                this.bool_PrizePoolSettingCV = true; 
                this.$v.selectedPrizePool.$touch();
                if (!this.$v.selectedPrizePool.$error) {
                    var that = this;
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;
                        if (this.newImg == true) {
                            this.postDataApiWithAttach(`/api/ppool/spps`, this.obj_PrizePoolMain,
                                function (d, s) {
                                    that.bool_PrizePoolSettingCV = false;
                                    that.bool_fullLoading = false;
                                    that.bool_fullScreen = false;
                                    if (s) {
                                        that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                    }
                                    that.getPrizePoolSetting();
                                });
                        } else {
                            this.postDataApi(`/api/ppool/spps`, this.obj_PrizePoolMain,
                                function (d, s) {
                                    that.bool_PrizePoolSettingCV = false;
                                    that.bool_fullLoading = false;
                                    that.bool_fullScreen = false;
                                    if (s) {
                                        that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                    }
                                    that.getPrizePoolSetting();
                                });
                        }
                } else {
                    const validation = this.$v["selectedPrizePool"];
                    if (!validation) {
                        return;
                    }
                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },

            ///dls mpromo start
            checkModuleAccess2(type) {
                return this.checkModuleAccess('PPS', 'P', type);
            },
            
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getPrizeSetting();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            CurrencyChange(value) {
                if (value != undefined) {
                    var that = this;
                    this.ddCurrencyList.find(function (val, idx) {
                        if (val.id == value) {
                            that.setThousandCurrency(that.CheckIsThousandCurrency(val.label, that), that);
                            that.str_preText=val.label;
                        }
                    });
                }
                this.rendering = false;
                //this.RenderCurrencyChange(value);
            },
            
            renderCurrency(ISOC) {
                return this.getLanguage['DB'][ISOC];
            },
           
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                // If the current item is not Agent, Disable it
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }
                // If the current items contains children (Recursion)
                if (item.children && item.children.length > 0) {
                    // Call itself, disableAgentGroupParent() to Disable the parent.
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            renderDLSPromoGroup(int_DLSPromoGroup) {
                return this.dd_DLSPromoGroup[int_DLSPromoGroup - 1].label;
            },
            
            getPrizeSetting() {
                if (this.searchAgi != null && this.searchCurrency != null) {
                    this.bool_fullLoading = true;
                    var that = this;
                    var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                    if (path) {
                        path += "&";
                    }

                    path += (
                        "&f.CI=" + (this.searchCurrency == null ? "" : this.searchCurrency) +
                        "&f.ATAGI=" + (this.searchAgent == null ? "" : this.searchAgent)
                    );                    
                    this.getDataApi(`/api/ppool/l?${path}`,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s && d.D.Items && d.D.Items.length > 0) {
                                that.int_TP = Math.max(d.D.TotalPages, 1);
                                that.int_Total = d.D.TotalItems;
                                that.arr_PrizeSetting = d.D.Items;
                                that.isSubAgent = d.D.Items[0].ISA;
                                that.genaretePrizeDropDown();
                                //that.resizeTableHead();
                            } else {
                                that.arr_PrizeSetting = [];
                            }
                        });
                }
            },
            
            ValidationPrizeErrMsg(value, langKey1 = "", langKey2 = "") {
                if (this.bool_PrizeCV) {
                    if (langKey1 == "") {
                        langKey1 = "PM";
                    }

                    if (langKey2 == "") {
                        langKey2 = value;
                    }

                    var validateObj = this.$v.obj_Prize[value];

                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[langKey1][langKey2]);
                    }
                    else if (validateObj.alphaNum != undefined && !validateObj.alphaNum) {
                        return String.format(this.utilGetErrorLanguage('1008'), this.getLanguage[langKey1][langKey2]);
                    }
                    else if (validateObj.numeric != undefined && !validateObj.numeric) {
                        return String.format(this.utilGetErrorLanguage('1009'), this.getLanguage[langKey1][langKey2]);
                    }
                    else if (validateObj.between != undefined && !validateObj.between) {
                        return String.format(this.utilGetErrorLanguage('1004'), this.getLanguage[langKey1][langKey2]);
                    }
                    else if (validateObj.decimal != undefined && !validateObj.decimal) {
                        return String.format(this.utilGetErrorLanguage('1007'), this.getLanguage[langKey1][langKey2]);
                    }
                    else if (validateObj.minValueValue != undefined && !validateObj.minValueValue) {
                        return String.format(this.utilGetErrorLanguage('4442'), this.getLanguage[langKey1][langKey2]);
                    }

                }
            },
           
            
            savePrize() {
                var that = this;
                this.obj_Prize.AGI = this.searchAgi;
                this.obj_Prize.CI = this.searchCurrency;

                this.bool_PrizeCV = true;
                this.$v.obj_Prize.$touch();

                if (!this.$v.obj_Prize.$error) {
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;
                    this.postDataApi(`/api/ppool/s`, this.obj_Prize,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                that.obj_Prize = {
                                    "I": 0,
                                    "RS": 2,
                                    "AGI": "",
                                    "PN": "",
                                    "PG": 1,
                                    "CA": 0,
                                    "NOS": 0,
                                    "GPI": null,
                                    "CI": null
                                };
                                that.bool_PrizeCV = false;
                                that.getPrizeSetting();
                            }
                        });
                } else {
                    //get the object for validating.
                    const validation = this.$v["obj_Prize"];
                    if (!validation) {
                        return;
                    }
                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            removePrize(d) {
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: d.I,
                            uts: d.UTS,
                            agi: d.AGI
                        };

                        this.postDataApi(`/api/ppool/d`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.getPrizeSetting();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },

            addPrizePool() {             
                this.bool_PrizePoolCV = true;
                this.obj_PrizePool.AGI = this.searchAgi;
                this.obj_PrizePool.CI = this.searchCurrency;
                this.$v.obj_PrizePool.$touch();
                if (!this.$v.obj_PrizePool.$error) {
                    this.obj_PrizePool.PPN = this.obj_PrizePool.APPN;
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;
                    var that = this;
                    this.postDataApi(`/api/ppool/appn`, this.obj_PrizePool,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                that.obj_PrizePool = {
                                    "I": 0,
                                    "RS": 2,
                                    "AGI": null,
                                    "CI": null,
                                    "APPN": null
                                };
                                that.bool_PrizePoolCV = false;
                                that.getPrizePoolSetting();
                            }
                        });
                }
                else {
                    //get the object for validating.
                    const validation = this.$v["obj_PrizePool"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },

            getPrizePoolSetting() {
                if (this.searchAgi != null && this.searchCurrency != null) {
                    this.bool_fullLoading = true;
                    var that = this;

                    var path = (
                        "f.CI=" + (this.searchCurrency == null ? "" : this.searchCurrency) +
                        "&f.AGI=" + (this.searchAgi == null ? "" : this.searchAgi)
                    );

                    this.getDataApi(`/api/ppool/ppl?${path}`,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s && d) {
                                that.obj_PrizePoolMain = d;
                                if (d.PrizePoolMainList && d.PrizePoolMainList.length > 0) {
                                    that.selectPrizePool(d.PrizePoolMainList[0]);
                                }
                            }
                        });
                }
            },
            updatePrizePoolStatus(event, data) {
                if (!event.target.checked) {
                    this.bool_fullLoading = true;
                    var that = this;
                    var dt = {
                        i: data.I,
                        uts: data.UTS,
                        agi: data.AGI
                    };
                    this.postDataApi(`/api/ppool/cppiu`, dt,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                data.RS = 1;
                                data.IsEdit = true;
                            }
                            else {
                                event.target.checked = !event.target.checked;
                            }
                        });
                } else {
                    data.IsEdit = true;
                    data.RS = 2;
                }
            },
            selectPrizePool(data) {
                this.selectedPrizePool = data;
                var bnl = [];
                if (this.dd_language && this.dd_language.length > 0) {
                    this.selectedLang = this.dd_language[0];
                    this.selectedPrizePool.TPPNL = [];
                    if (this.selectedPrizePool.TPPN) {
                        var bn = [];
                        bn = this.selectedPrizePool.TPPN.split("{<=}");
                        if (bn.length > 0) {
                            bn.forEach(function (item) {
                                var row = item.split("{=>}");
                                bnl[row[0]] = row[1];
                            });
                        }
                    } else if (this.dd_language.length > 0) {
                        var that = this;
                        this.dd_language.forEach(function (item) {
                            bnl[item.id] = that.selectedPrizePool.PPN;
                        });
                    }
                    this.selectedPrizePool.TPPNL = bnl;
                    //if (!this.selectedPrizePool.TPPNL['en']) {
                    //    this.selectedPrizePool.TPPNL['en'] = this.selectedPrizePool.PPN;
                    //}
                }
            },
            updateTranslation() {
                if (this.selectedPrizePool) {
                    if (this.selectedPrizePool.TPPNL) {                        
                        var bnl = [];
                        Object.keys(this.selectedPrizePool.TPPNL).forEach(key => {
                            if (this.selectedPrizePool.TPPNL[key] != '')
                                bnl.push(key + "{=>}" + this.selectedPrizePool.TPPNL[key]);
                        });
                        if (bnl.length > 0) {
                            this.selectedPrizePool.TPPN = bnl.join("{<=}");
                        }
                    }
                    this.selectedPrizePool.IsEdit = true;
                }
            },

            removePrizePool(d) {
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: d.I,
                            uts: d.UTS,
                            agi: d.AGI,
                            ci: d.CI
                        };

                        this.postDataApi(`/api/ppool/dpp`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.getPrizePoolSetting();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            ctrPage(newPage, inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getPrizeSetting();
            },
        },
        
        watch: {
            getLanguage() {
                this.getPrizeSetting();
            },
            'obj_Prize.NOS': function (newVal, oldVal) {
                if (!newVal)
                    this.obj_Prize.GPI = null;
            },
            'obj_Prize.PG': function (newVal, oldVal) {
                if (newVal == 1) {
                    this.obj_Prize.NOS = 0;
                    this.obj_Prize.GPI = null;
                } else if (newVal == 2) {
                    this.obj_Prize.CA = 0;
                }
            },
        },
        created() {
            this.$parent.showSubMenu = 'P';
            this.$parent.showActiveMenu = 'P.PPS';
            this.$parent.showSubSubMenu = 'RS8';
            
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
            if (this.getUserInfo.AT == 3) {
                this.searchAgi = this.getUserInfo.AGI;
            };
            if (this.$route.query.agi) {
                var agi = this.$route.query.agi.split("-");
                this.searchAgi = agi[1];
                this.searchAgent = this.$route.query.agi;
            }
            if (this.$route.query.ci) {
                this.searchCurrency = this.$route.query.ci;
            }
            this.getDropdownList();
            this.setThousandCurrency(false);
           
        },
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Promotion/PrizePoolSetup.vue